module.exports = __webpack_public_path__ + "static/media/daristaGoldLogoPM.d7cb9f81.png";